// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TlrjN","footer":"styles_footer__2UgAM"};